import { useMultiuserContext, usePresentatorId } from "@solidwhite/multiuser";
import { useUsers } from "y-presence";

const UserList = ({ ...props }) => {
  const { connected } = useMultiuserContext();

  if (!connected) return null;

  return <UserListConnected />;
};

const UserListConnected = () => {
  const { awareness } = useMultiuserContext();

  const users = useUsers(
    awareness,
    (state) =>
      // @ts-ignore
      Array.from(state)
        // @ts-ignore
        // .filter(([id, data]) => id != awareness.clientID)
        // @ts-ignore
        .filter(([id, data]) => !data.presentator)
        // @ts-ignore
        .map(([id, data]) => id),
    (a, b) => {
      return a.length == b.length;
    },
  );

  return (
    <div
      style={{
        position: "absolute",
        top: "7vw",
        left: "2vw",
        padding: ".5vw",
        height: "16vh",
        maxHeight: "16vh",
        width: "10vw",
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        backdropFilter: "blur(10px)",
        overflow: "auto",
        overflowX: "hidden",
      }}
    >
      <PresentatorEntry />
      {users.map((u) => (
        <UserListEntry id={u} key={`userlistentry_${u}`} />
      ))}
    </div>
  );
};

const PresentatorEntry = () => {
  const { awareness } = useMultiuserContext();

  const users = useUsers(
    awareness,
    (state) =>
      // @ts-ignore
      Array.from(state)
        // @ts-ignore
        // .filter(([id, data]) => id != awareness.clientID)
        // @ts-ignore
        .filter(([id, data]) => data.presentator)
        // @ts-ignore
        .map(([id, data]) => id),
    (a, b) => {
      return a.length == b.length;
    },
  );

  if (users.length <= 0) return null;

  return <UserListEntry id={users[0]} />;
};

const UserListEntry = ({ id }) => {
  const { awareness } = useMultiuserContext();

  const { color } = useUsers(
    awareness,
    (state) => {
      return state.get(id);
    },
    (a, b) => {
      return a.color == b.color;
    },
  );
  const { name } = useUsers(
    awareness,
    (state) => {
      return state.get(id);
    },
    (a, b) => {
      return a.name == b.name;
    },
  );

  return (
    <div
      style={{
        color: color,
      }}
    >
      {name}
    </div>
  );
};

export default UserList;
